import { createContext, useContext, useEffect, useMemo, useState } from "react";

const dict = {
  fr: {
    app_name: "Cen21 Marketing",
    tagline: "Commandes créatives & inventaire matériel — pilotés d'un coup d'œil.",
    login: "Se connecter",
    logout: "Déconnexion",
    register: "Créer un compte",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom complet",
    role: "Rôle",
    no_account: "Pas de compte ?",
    has_account: "Déjà inscrit ?",
    submit: "Valider",
    dashboard: "Tableau de bord",
    orders: "Commandes",
    equipment: "Matériel",
    users: "Utilisateurs",
    kpi_pending: "En attente",
    kpi_in_progress: "En cours",
    kpi_review: "En révision",
    kpi_completed: "Terminées",
    kpi_equipment_out: "Matériel sorti",
    kpi_available: "Disponible",
    kpi_types: "Types de matériel",
    kpi_team: "Équipe",
    new_order: "Nouvelle commande",
    title: "Titre",
    description: "Description",
    type: "Type",
    priority: "Priorité",
    status: "Statut",
    deadline: "Échéance",
    assigned_to: "Assigné à",
    attachments: "Fichiers joints",
    add_comment: "Ajouter un commentaire",
    comment: "Commentaire",
    deliver: "Livrer la commande",
    notify_whatsapp: "Prévenir sur WhatsApp",
    whatsapp_no_phone: "Aucun numéro enregistré pour cette personne",
    whatsapp_no_assignee: "Commande non assignée",
    poster: "Affiche",
    video: "Vidéo",
    low: "Basse",
    medium: "Moyenne",
    high: "Haute",
    urgent: "Urgente",
    pending: "En attente",
    in_progress: "En cours",
    review: "En révision",
    completed: "Terminé",
    rejected: "Refusé",
    admin: "Admin",
    designer: "Designer",
    videographer: "Vidéaste",
    photographer: "Photographe",
    member: "Membre",
    agent: "Agent",
    all: "Tous",
    search: "Rechercher…",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add_equipment: "Ajouter du matériel",
    category: "Catégorie",
    quantity: "Quantité",
    available: "Disponible",
    photo: "Photo",
    check_out: "Sortie",
    check_in: "Entrée",
    borrower: "Emprunteur",
    purpose: "Objet / Projet",
    expected_return: "Retour prévu",
    movement_history: "Historique des mouvements",
    upload_file: "Téléverser un fichier",
    my_orders: "Mes commandes",
    all_orders: "Toutes les commandes",
    view_details: "Détails",
    comments_activity: "Commentaires & activité",
    deliverables: "Livrables",
    no_data: "Aucune donnée",
    change_role: "Changer de rôle",
    created_by: "Créé par",
    kanban: "Kanban",
    table: "Table",
    welcome_back: "Bon retour",
    signup_title: "Rejoignez l'équipe créative",
    login_title: "Retour au studio",
    quick_add_comment: "Écrire un commentaire…",
    filter_status: "Filtrer par statut",
    filter_type: "Filtrer par type",
    calendar: "Calendrier",
    today: "Aujourd'hui",
    notifications: "Notifications",
    mark_all_read: "Tout marquer lu",
    no_notifications: "Aucune notification",
    overdue: "En retard",
    overdue_returns: "Retours en retard",
    overdue_banner: "matériel(s) dont la date de retour est dépassée",
    export_csv: "Exporter CSV",
    open_loans: "Prêts en cours",
    returned: "Retourné",
    kpi_overdue: "Retours en retard",
    my_orders_hint: "Vos commandes livrées : approuvez ou demandez une retouche.",
    to_review: "À valider",
    approve: "Approuver",
    request_revision: "Demander une retouche",
    revision_placeholder: "Décrivez les modifications souhaitées…",
    approved: "Commande approuvée",
    revision_sent: "Retouche demandée — l'assigné est prévenu",
    drag_hint: "Glissez une carte pour changer son statut",
    digest: "Résumé hebdomadaire",
    signature: "Signature de l'emprunteur",
    signature_hint: "Signez avec la souris ou le doigt",
    signature_required: "La signature de l'emprunteur est requise pour une sortie",
    clear: "Effacer",
    team_stats: "Statistiques équipe",
    team_stats_hint: "Commandes livrées par membre ce mois-ci",
    forgot_password: "Mot de passe oublié ?",
    forgot_hint: "Entrez votre e-mail : nous vous enverrons un lien de réinitialisation valable 1 heure.",
    forgot_sent: "Si un compte existe pour cet e-mail, un lien vient d'être envoyé. Vérifiez votre boîte de réception.",
    send_link: "Envoyer le lien",
    reset_password: "Nouveau mot de passe",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    password_mismatch: "Les mots de passe ne correspondent pas",
    password_reset_ok: "Mot de passe modifié. Connectez-vous.",
    search_global: "Rechercher une commande ou un matériel…",
    receipt_pdf: "Bon de sortie PDF",
    templates: "Modèles",
    from_template: "Depuis un modèle",
    save_as_template: "Enregistrer comme modèle",
    template_name: "Nom du modèle",
    days_to_deadline: "Délai (jours)",
    manage_templates: "Gérer les modèles",
    reserve: "Réserver",
    reservations: "Réservations",
    start_date: "Du",
    end_date: "Au",
    reserved_ok: "Réservation enregistrée",
    cancel_reservation: "Annuler",
    no_reservations: "Aucune réservation à venir",
    offline_mode: "Hors-ligne — les sorties/entrées signées seront synchronisées au retour du réseau",
    offline_saved: "Réseau indisponible : mouvement enregistré hors-ligne, il sera synchronisé automatiquement",
    offline_pending: "mouvement(s) en attente de synchronisation",
    offline_synced: "mouvement(s) synchronisé(s)",
    sync_now: "Synchroniser",
    offline_rejected: "refusé par le serveur",
    deadline_soon: "Échéance proche",
    events: "Événements",
    new_event: "Nouvel événement",
    events_hint: "Équipe, commandes et matériel réservés par événement",
    location: "Lieu",
    team: "Équipe assignée",
    owner: "Responsable",
    event: "Événement",
    no_event: "Aucun événement",
    reserved_equipment: "Matériel réservé",
    ev_upcoming: "À venir",
    register_role_hint: "Les rôles Membre et Agent sont attribués uniquement par un administrateur.",
    invite_only_title: "Sur invitation uniquement",
    invite_only_hint: "La création de compte se fait par invitation. Demandez à un administrateur de vous envoyer un lien d'activation par e-mail.",
    invite_title: "Activez votre compte",
    invite_hint: "Vous avez été invité par",
    invite_activate: "Activer mon compte",
    invite_accepted: "Compte activé, bienvenue !",
    invite_collaborator: "Inviter un collaborateur",
    invite_send: "Envoyer l'invitation",
    invite_pending: "Invitations en attente",
    invite_sent: "Invitation envoyée",
    invite_resent: "Invitation renvoyée",
    invite_revoked: "Invitation révoquée",
    invite_expires: "Expire le",
    resend: "Renvoyer",
    revoke: "Révoquer",
    upcoming_events: "Prochains événements",
    creative_report: "Rapport de rendu",
    period: "Période",
    from: "Du",
    to: "Au",
    download_pdf: "Télécharger le PDF",
    range_invalid: "La date de début doit précéder la date de fin.",
    movement_deleted: "Mouvement supprimé",
    movement_delete_title: "Supprimer ce mouvement ?",
    movement_delete_hint: "L'entrée disparaîtra de l'historique et de l'export. S'il s'agit d'une sortie non rendue, les unités seront remises en stock.",
    my_profile: "Mon profil",
    phone: "Téléphone",
    phone_hint: "Numéro au format international (ex. +243990000000) pour recevoir les alertes par SMS. Laissez vide pour désactiver.",
    phone_saved: "Numéro enregistré",
    profile_saved: "Profil mis à jour",
    daily_report: "Rapport journalier",
    daily_report_hint: "Partagez votre rapport du jour avec toute l'équipe — chaque rapport compte comme un rendu.",
    daily_report_placeholder: "Ce que j'ai fait aujourd'hui…",
    report_submitted: "Rapport envoyé",
    today: "Aujourd'hui",
    edited: "modifié",
    saved: "Enregistré",
    reports_count: "rapports",
    output_label: "rendus",
    no_checklist: "Aucune checklist",
    upcoming_events_hint: "Les 3 événements à venir et l'avancement de leur checklist",
    view_all: "Tout voir",
    ev_ongoing: "En cours",
    ev_done: "Terminé",
    ev_cancelled: "Annulé",
    roadmap_pdf: "Feuille de route PDF",
    checklist: "Checklist",
    checklist_default: "Ajouter les étapes par défaut",
    checklist_add: "Nouvelle tâche…",
    edit_order: "Modifier la commande",
    order_updated: "Commande mise à jour",
  },
  en: {
    app_name: "Cen21 Marketing",
    tagline: "Creative orders & equipment inventory — one glance to control.",
    login: "Sign in",
    logout: "Sign out",
    register: "Create account",
    email: "Email",
    password: "Password",
    name: "Full name",
    role: "Role",
    no_account: "No account?",
    has_account: "Already registered?",
    submit: "Submit",
    dashboard: "Dashboard",
    orders: "Orders",
    equipment: "Equipment",
    users: "Users",
    kpi_pending: "Pending",
    kpi_in_progress: "In progress",
    kpi_review: "In review",
    kpi_completed: "Completed",
    kpi_equipment_out: "Equipment out",
    kpi_available: "Available",
    kpi_types: "Equipment types",
    kpi_team: "Team",
    new_order: "New order",
    title: "Title",
    description: "Description",
    type: "Type",
    priority: "Priority",
    status: "Status",
    deadline: "Deadline",
    assigned_to: "Assigned to",
    attachments: "Attachments",
    add_comment: "Add a comment",
    comment: "Comment",
    deliver: "Deliver order",
    notify_whatsapp: "Notify on WhatsApp",
    whatsapp_no_phone: "No phone number on file for this person",
    whatsapp_no_assignee: "Order is not assigned",
    poster: "Poster",
    video: "Video",
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
    pending: "Pending",
    in_progress: "In progress",
    review: "Review",
    completed: "Completed",
    rejected: "Rejected",
    admin: "Admin",
    designer: "Designer",
    videographer: "Videographer",
    photographer: "Photographer",
    member: "Member",
    agent: "Agent",
    all: "All",
    search: "Search…",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add_equipment: "Add equipment",
    category: "Category",
    quantity: "Quantity",
    available: "Available",
    photo: "Photo",
    check_out: "Check out",
    check_in: "Check in",
    borrower: "Borrower",
    purpose: "Purpose",
    expected_return: "Expected return",
    movement_history: "Movement history",
    upload_file: "Upload file",
    my_orders: "My orders",
    all_orders: "All orders",
    view_details: "Details",
    comments_activity: "Comments & activity",
    deliverables: "Deliverables",
    no_data: "No data",
    change_role: "Change role",
    created_by: "Created by",
    kanban: "Kanban",
    table: "Table",
    welcome_back: "Welcome back",
    signup_title: "Join the creative team",
    login_title: "Back to the studio",
    quick_add_comment: "Write a comment…",
    filter_status: "Filter by status",
    filter_type: "Filter by type",
    calendar: "Calendar",
    today: "Today",
    notifications: "Notifications",
    mark_all_read: "Mark all read",
    no_notifications: "No notifications",
    overdue: "Overdue",
    overdue_returns: "Overdue returns",
    overdue_banner: "item(s) past their expected return date",
    export_csv: "Export CSV",
    open_loans: "Open loans",
    returned: "Returned",
    kpi_overdue: "Overdue returns",
    my_orders_hint: "Your delivered orders: approve or request a revision.",
    to_review: "To review",
    approve: "Approve",
    request_revision: "Request revision",
    revision_placeholder: "Describe the changes you need…",
    approved: "Order approved",
    revision_sent: "Revision requested — assignee notified",
    drag_hint: "Drag a card to change its status",
    digest: "Weekly digest",
    signature: "Borrower signature",
    signature_hint: "Sign with mouse or finger",
    signature_required: "Borrower signature is required for a check-out",
    clear: "Clear",
    team_stats: "Team stats",
    team_stats_hint: "Orders delivered per member this month",
    forgot_password: "Forgot password?",
    forgot_hint: "Enter your email: we'll send a reset link valid for 1 hour.",
    forgot_sent: "If an account exists for this email, a link has just been sent. Check your inbox.",
    send_link: "Send link",
    reset_password: "New password",
    new_password: "New password",
    confirm_password: "Confirm password",
    password_mismatch: "Passwords do not match",
    password_reset_ok: "Password changed. Please sign in.",
    search_global: "Search an order or equipment…",
    receipt_pdf: "Check-out receipt PDF",
    templates: "Templates",
    from_template: "From a template",
    save_as_template: "Save as template",
    template_name: "Template name",
    days_to_deadline: "Lead time (days)",
    manage_templates: "Manage templates",
    reserve: "Reserve",
    reservations: "Reservations",
    start_date: "From",
    end_date: "To",
    reserved_ok: "Reservation saved",
    cancel_reservation: "Cancel",
    no_reservations: "No upcoming reservations",
    offline_mode: "Offline — signed check-outs/check-ins will sync when back online",
    offline_saved: "Network unavailable: movement saved offline, it will sync automatically",
    offline_pending: "movement(s) waiting to sync",
    offline_synced: "movement(s) synced",
    sync_now: "Sync now",
    offline_rejected: "rejected by server",
    deadline_soon: "Deadline soon",
    events: "Events",
    new_event: "New event",
    events_hint: "Team, orders and reserved equipment per event",
    location: "Location",
    team: "Assigned team",
    owner: "Owner",
    event: "Event",
    no_event: "No event",
    reserved_equipment: "Reserved equipment",
    ev_upcoming: "Upcoming",
    register_role_hint: "Member and Agent roles are granted by an administrator only.",
    invite_only_title: "By invitation only",
    invite_only_hint: "Accounts are created by invitation. Ask an administrator to send you an activation link by email.",
    invite_title: "Activate your account",
    invite_hint: "You were invited by",
    invite_activate: "Activate my account",
    invite_accepted: "Account activated, welcome!",
    invite_collaborator: "Invite a collaborator",
    invite_send: "Send invitation",
    invite_pending: "Pending invitations",
    invite_sent: "Invitation sent",
    invite_resent: "Invitation resent",
    invite_revoked: "Invitation revoked",
    invite_expires: "Expires on",
    resend: "Resend",
    revoke: "Revoke",
    upcoming_events: "Upcoming events",
    creative_report: "Performance report",
    period: "Period",
    from: "From",
    to: "To",
    download_pdf: "Download PDF",
    range_invalid: "The start date must come before the end date.",
    movement_deleted: "Movement deleted",
    movement_delete_title: "Delete this movement?",
    movement_delete_hint: "The entry will disappear from the history and the export. For an unreturned check-out, the units go back to stock.",
    my_profile: "My profile",
    phone: "Phone",
    phone_hint: "International format (e.g. +243990000000) to receive SMS alerts. Leave empty to disable.",
    phone_saved: "Phone saved",
    profile_saved: "Profile updated",
    daily_report: "Daily report",
    daily_report_hint: "Share your report of the day with the whole team — each report counts as one output.",
    daily_report_placeholder: "What I did today…",
    report_submitted: "Report sent",
    today: "Today",
    edited: "edited",
    saved: "Saved",
    reports_count: "reports",
    output_label: "outputs",
    no_checklist: "No checklist",
    upcoming_events_hint: "Next 3 events and their checklist progress",
    view_all: "View all",
    ev_ongoing: "Ongoing",
    ev_done: "Done",
    ev_cancelled: "Cancelled",
    roadmap_pdf: "Roadmap PDF",
    checklist: "Checklist",
    checklist_default: "Add default steps",
    checklist_add: "New task…",
    edit_order: "Edit order",
    order_updated: "Order updated",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "fr");
  useEffect(() => localStorage.setItem("lang", lang), [lang]);
  const value = useMemo(() => ({ lang, setLang, t: (k) => dict[lang]?.[k] || dict.fr[k] || k }), [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
